import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('EstoxConfirmationDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    '$element',
    'close',
    'data',
    estoxConfirmationDialogCtrl,
  ]);

function estoxConfirmationDialogCtrl(
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  $element,
  close,
  data,
) {
  var vm = this;
  vm.model = data;
  //console.log(data);

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.create = function() {
    vm.creating = true;
    vm.error = null;
    return $http.post(appUrls.api + '/api/relation/CreateInEstox', vm.model).then(
      function({ data }) {
        vm.creating = false;
        if (data.created) {
          flySvc.success('msgCompanyCreatedInEstox');
          $element.modal('hide');
          close(null, 500);
        } else {
          vm.error = data.error
            .replace(/\\n|\\r/g, '<br/>')
            .replace(/\"/g, '')
            .trim();
          return '';
        }
      },
      function(error) {
        vm.creating = false;
        flySvc.error(error);
        return '';
      },
    );
  };
}
